import Card from '@/models/Accounts/Shared/Cards/Card';

export default class UpdateCardRequest extends Card {

    public constructor(card: Card) {
        super();
        if (card) {
            this.enabled = card.enabled;
        }
    }
}